<template>
  <fields-list
    :update-component="customFieldsUpdateKey"
    :fields="!!fields ? fields : []"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { mapActions } from "vuex";
import { bus } from "@/main.js";

export default {
  name: "CustomFieldsTab",

  components: {
    FieldsList,
  },

  mixins: [objectManagementMixin],

  props: {
    editingData: {
      type: Boolean,
      required: true,
    },

    customFieldsInputs: {
      type: Array,
    },

    customFieldsValues: {
      type: Object,
    },
  },

  data() {
    return {
      customFieldsUpdateKey: 0,
      fields: []
    }
  },

  mounted() {
    this.fieldsCalculate();
    bus.$on("update-custom-field-value", () => {
      this.fieldsCalculate();
    })
  },

  destroyed() {
    bus.$off("update-custom-field-value");
  },

  methods: {
    ...mapActions(["GET_LIST", "fetchAllUsers"]),

    fieldsCalculate() {
      let fields = [];
      this.customFieldsInputs.forEach(input => {
        let field = {
          label: input.label,
          value: null,
          varName: input.uuid,
          inputType: input.input_type,
          disabled: input.disabled,
          required: input.required,
          optionsListName: input.list_name,
          size: this.customFieldInputSize(input.size),
          checkboxOptions: [{ id: input.label }],
          id: input.id,
          uuid: input.uuid,
        };

        if (this.customFieldsValues[input.uuid] && input.input_type === 'select') {
          if (!this.editingData) {
            this.loadOptions(this.customFieldsValues[input.uuid], input.list_name).then(options => {
              field.value = this.parseSelectValue([this.customFieldsValues[input.uuid]], options)
              this.customFieldsUpdateKey++;
            }
            );
          } else {
            field.value = this.customFieldsValues[input.uuid]
          }
        } else if (this.customFieldsValues[input.uuid] && input.input_type === 'multiselect') {
          if (!this.editingData) {
            this.loadOptions(this.customFieldsValues[input.uuid], input.list_name).then(options => {
              field.value = this.parseSelectValue(this.customFieldsValues[input.uuid], options)
              this.customFieldsUpdateKey++;
            }
            );
          } else {
            field.value = this.customFieldsValues[input.uuid]
          }
        } else {
          field.value = this.customFieldsValues[input.uuid];
        }

        fields.push(field);
      });

      this.fields = fields;
    },

    customFieldInputSize(size) {
      switch (size) {
        case "small":
          return 100/3+'%'
        case "medium":
            return (100/3)*2+'%'
        case "large":
          return '100%'
        default:
          return 100/3+'%';
      }
    },

    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return true;
    },

    /**
     * Loads the select options locally.
     */
    async loadOptions(value, selectOptions) {
      let options = this.$store.getters.getListOfOptionsByListName(
        selectOptions,
        [value]
      );
      if(selectOptions != null){
      if (!!options && options.custom) {
        options = Object.values(options);
        options.pop();
        return options;
      } else if (!options) {
        try {
          options = await this.GET_LIST({
            listName: selectOptions,
            code: [value]
          });
        } catch (error) {
          console.error(error);
        }
      }
      }
      return options;
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/newComponents/StockManagement/CustomFieldsTab.vue